import axios from "axios";
const uri = "https://www.lefisc.com.br/api/monitoramentoNCM/cliente/notainicial/64ad62a25fe48a9e8bcd84df737dd40b";
const tok = "64ad62a25fe48a9e8bcd84df737dd40b";
export default {
    getDadosNcm(ncm){
        return axios
        .get(`https://www.lefisc.com.br/api/monitoramentoNCM/Cliente/dadosNCM/${ncm}/64ad62a25fe48a9e8bcd84df737dd40b`)
        .then(res=> res.data)
        .catch(err => console.log(err))
    },
    getTitulo(){
        return axios
        .get(`https://www.lefisc.com.br/api/monitoramentoNCM/cliente/notainicial/64ad62a25fe48a9e8bcd84df737dd40b`)
        .then(res=> res.data)
        .catch(err => console.log(err))
    }
}